import { useRef } from 'react';
import { sameElements } from '~/utils/array';

/**
 * `elements`, or the array this hook last returned while it holds the same
 * elements in the same order, so a list rebuilt with the same content does not
 * read as a change to whatever depends on it.
 */
export function useStableElements<T>(elements: readonly T[]): readonly T[] {
    const stable = useRef(elements);
    if (!sameElements(stable.current, elements)) {
        stable.current = elements;
    }
    return stable.current;
}
